//Init all inputs of page
initInputs();


//Init inputs
function initInputs(container = $(document)) {

    //Checkbox
    container.find(".checkbox label").each(function (e) {
        $label = $(this).html();
        $(this).html('<span>'+$label+'</span>');
    });
    container.find(".checkbox input[type=checkbox]:checked").each(function (e) {
        $(this).parent().addClass('checked')
    });
    container.find(".checkbox input[type=checkbox]").change(function (e) {
        var checked = $(this).is(':checked');
        console.log(checked);
        if (checked) {
            $(this).parent().addClass('checked');
        } else {
            $(this).parent().removeClass('checked');
        }
    }).focusin(function() {
        $(this).parent().addClass('focus');
    }).focusout(function() {
        $(this).parent().removeClass('focus');
    });

    // Input Text
    $(".input-text [name]").each(function (e) {
        let container = $(this).parents(".input-text").eq(0)
        let input = $(this)
        input.focusin(function() {
            container.addClass('active');
        }).focusout(function() {
            // console.log(input.val())
            if (!input.val()) container.removeClass('active');
        });

    });

    //Radio
    // container.find(".cf_radio input[type=radio]:checked").each(function (e) {
    //     $(this).parent().addClass('checked')
    // });
    // container.find(".cf_radio input[type=radio]").change(function (e) {
    //     $(this).parent().addClass('checked');
    //     container.find(".cf_radio input[type=radio]").each(function (e) {
    //         $(this).parents('.radio').each(function () {
    //             if (!$(this).find('input[type=radio]:checked').length) {
    //                 $(this).removeClass('checked');
    //             }
    //         });
    //     });
    // }).focusin(function() {
    //     $(this).parent().addClass('focus');
    // }).focusout(function() {
    //     $(this).parent().removeClass('focus');
    // });

    //Input Text
    // container.find(".cf_field [name]").each(function (e) {
    //     $(this).focus(function (e) {
    //         $(this).parent().addClass('active');
    //     });
    //     $(this).blur(function (e) {
    //         if (!$(this).val()) $(this).parent().removeClass('active');
    //     })
    // });

    //Select
    // container.find(".select select").focusin(function() {
    //     $(this).parent().addClass('focus');
    // }).focusout(function() {
    //     $(this).parent().removeClass('focus');
    // });

    //Multiselect
    // container.find(".multi-select").each(function (e) {
    //     $(this).attr('tabindex', 0);
    //     $(this).find('.label').click(function (e) {
    //         toggleSelect($(this).parent());
    //     });
    // });
}
